{
  "mainHeader": ["*●* **HM Індекс**", "*⊙* Сфери", "*≡* Шкали"],
  "spheresHeader": ["*●* HM Індекс", "*⊙* **Сфери**", "*≡* Шкали"],
  "healthyMindIndex": "*●*Індекс Healthy Mind ",
  "profileScoreCard": {
    "fromLastCheckUp": "з останнього чекапу"
  },
  "mentalBalanceCard": {
    "title": "Модель психологічної рівноваги",
    "details": "> [info] Це карта вашого психологічного добробуту.\nВона об’єднує 8 сфер життя, і показує, де зараз зосереджено основні ресурси, а де може знадобитися додаткова підтримка.\n > [info]\nНемає «правильних» чи «неправильних» результатів це лише портрет того, як ви почуваєтесь сьогодні.\nНатисніть на будь-яку сферу, щоб побачити шкали з простими поясненнями, а також, як окремі показники пов’язані з вашим самопочуттям і рівнем стресу, і також практичні рекомендації."
  },
  "MobileDialog": {
    "close": "Закрити"
  },
  "recommendations": {
    "open": "Переглянути детально",
    "close": "Закрити",
    "importantMessageIcon": "Важливо!"
  },
  "scalesCard": {
    "title": "Шкали вашого ментального стану",
    "subTitle": "В переліку нижче шкали розміщені у порядку зменшення їх впливу на сферу\n(від найбільш до менш вагомих)",
    "open": "Детальний опис"
  },
  "scalesCritical": {
    "title": "Критичні шкали",
    "subTitle": "Кожна сфера містить кілька шкал — вони вимірюють різні психоемоційні стани.\nНижче відображені ваші найкритичніші показники"
  },
  "scalesDynamics": {
    "title": "Шкали ментального стану",
    "filterTrigger": "Обрати шкалу",
    "filterDescription": "Оберіть шкали для їх відображення"
  },
  "dynamicOfIndicators": {
    "title": "Сфери та Індекс Healthy Mind",
    "filterTrigger": "Обрати сферу",
    "filterDescription": "Оберіть показники для їх відображення"
  },
  "Scales": {
    "title": "*≡* Шкали ментального стану",
    "subTitle": ["*●* HM Індекс", "*⊙* Сфери", "*≡* **Шкали**"],
    "scaleCard": {
      "open": "Детальний стан",
      "close": " Згорнути Детальний стан",
      "chartTitle": "Динаміка шкали {{name}}",
      "accordionTrigger": "Що таке шкала"
    }
  },
  "linearChart": {
    "bottomLable": "Чекап {{number}}"
  },
  "disclaimer": {
    "text": "Результати діагностики мають інформаційний характер і не є діагнозом. За потреби вони можуть стати приводом для консультації з фахівцем з ментального здоров’я.",
    "close": "Закрити"
  }
}
